import { Topic, messageFactory, } from '../../events';
export const onAVStopped = async (id, position) => {
    const partial = {
        position,
        item: {
            type: 'content',
            id,
        },
    };
    return Promise.all([
        messageFactory(Topic.PLAYBACK_PAUSED, partial),
        messageFactory(Topic.SYNC_PROGRESS),
    ]);
};
//# sourceMappingURL=onAVStopped.js.map